/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unstable-nested-components */
import React, { FC, useMemo, useState } from 'react';
import { styled } from 'linaria/lib/react';
import { theme, useBreakpoint } from '@mtsbank/ui-kit';
import { Payee } from '@root/api/ump-catalog-manager';
import { serviceTopClickGtm } from '@root/utils/gtm/cyber/events';
import { TileButton } from '../Cyber/buttons/TileButton';
import { Carousel } from '../Uikit/Carousel';
type CyberTopProps = {
  blocks: Payee[];
};
export const CyberTop: FC<CyberTopProps> = ({
  blocks
}) => {
  const [, setSlide] = useState(0);
  const navHandler = (id: number) => setSlide(id);
  const {
    isMobile,
    isTablet
  } = useBreakpoint();
  const mobileBlocks = 4;
  const tabletBlocks = 4;
  const desktopBlocks = 4;
  const makeSlides = (length: number) => blocks?.length ? Array.from({
    length: Math.ceil(blocks.length / length)
  }, (_, i) => i + 1) : [];
  const renderSlideFn = (blocksSize: number, subtractIndex = false) => (part: number, index: number) => <SlideWrapper key={part}>
          {blocks.slice((part - 1) * blocksSize - (subtractIndex ? index : 0), part * blocksSize - (subtractIndex ? index : 0)).map(({
      providerName,
      features
    }) => <TileButton slider key={features?.tsp_url as string} title={providerName} onClick={() => serviceTopClickGtm(providerName)} icon={features?.tsp_picture_web}
    // merchant={features?.merchant_association_for_WEB}
    url={features?.tsp_url as string} />)}
        </SlideWrapper>;
  const slides = isMobile ? makeSlides(4).map(renderSlideFn(mobileBlocks, true)) : isTablet ? makeSlides(4).map(renderSlideFn(tabletBlocks, true)) : makeSlides(desktopBlocks).map(renderSlideFn(desktopBlocks));
  return <CarouselWrapper>
      <Carousel autoplay={false} controlsPosition="top" nextHandler={navHandler} prevHandler={navHandler} heading="Популярное">
        {useMemo(() => [...slides], [slides])}
      </Carousel>
    </CarouselWrapper>;
};
const CarouselWrapper = /*#__PURE__*/styled("div")({
  name: "CarouselWrapper",
  class: "c6lbyma"
});
const SlideWrapper = /*#__PURE__*/styled("div")({
  name: "SlideWrapper",
  class: "stvfvyj"
});

require("./CyberTop.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./CyberTop.tsx");